import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { ModalContainer, CloseModalIcon, InputContainer, CenteredRow } from '../styles';
import { connect } from 'react-redux';
import PinInput from '../../../../../components/pin-input/PinInput';
import { auOnBoardingConstants } from '../OnBoardingConstants';
import { OTP_WAIT_TIME } from '../../../../../utils/constants';
import {
  sendOTPAuRevamped,
  sendOtpOnMobile,
  verifyMobileOtp,
  verifyOTPAuRevamp
} from '../../../../../redux/actions/otp-request/otp-request-action';
import {
  activateLoader,
  disableLoader
} from '../../../../../redux/actions/ui-trigger/ui-trigger-action';
import { changeOnBoardingScreen } from '../../../../../redux/actions/onboarding/new-onboarding-action';
import {
  FLOW_TYPE_ONBOARDING,
  OTP_PAGE,
  SIGNUP
} from '../../../../../utils/constants/eventsConstants';
import CommonButton from '../../../../../components/common-button/CommonButton';
import { changeNiumForexScreen } from '../../../../../redux/actions/nium-forex/nium-forex-action';
import { NF_SCREENS } from '../../../../nium-forex/root/screenConstants';
import { logEvent } from '../../../../../utils/events/logUserEvents';
import { LOG_TYPE } from '../../../../../utils/events/eventsConstants';
import { CLOSE_HEAVY_ICON } from '@Images';

let timer: ReturnType<typeof setTimeout>;

type OTPRequestDataProps = {
  mobileNumber: string;
  mobileCountryCode: string;
};
type OTPRequestNiumForexDataProps = {
  is_send_otp: boolean;
  mobile_country_code: string;
  mobile_number: string;
};

type OTPModalProps = {
  onClose: (state: boolean) => void;
  remitter_individual_mobile_country_code: string;
  inputPhoneNumber: string;
  sendOTPAuRevamped: (data: OTPRequestDataProps) => any;
  verifyOTPAuRevamp: (data: any) => any;
  activateLoader: () => void;
  disableLoader: () => void;
  changeOnBoardingScreen: (nextScreen: string) => void;
  changeNiumForexScreen: (data: string) => void;
  mobileCountryCode: string;
  isNiumForexUser: boolean;
  countryCode: string;
  verifyMobileOtp: any;
  sendOtpOnMobile: (data: OTPRequestNiumForexDataProps) => any;
  formID: string;
};

const OtpModal: React.FC<any> = ({
  mobileCountryCode,
  onClose,
  inputPhoneNumber,
  sendOTPAuRevamped,
  verifyOTPAuRevamp,
  activateLoader,
  disableLoader,
  changeOnBoardingScreen,
  changeNiumForexScreen,
  isNiumForexUser,
  countryCode,
  verifyMobileOtp,
  sendOtpOnMobile,
  formID
}: OTPModalProps) => {
  type StateProps = {
    otpSent: boolean;
    otpValue: string;
    counter: number;
    otpSentRetryCount: number;
  };
  const [otpState, setOtpState] = useState<StateProps>({
    otpSent: false,
    otpValue: '',
    counter: OTP_WAIT_TIME,
    otpSentRetryCount: 0
  });
  const [countDown, setCountDown] = useState<number>(OTP_WAIT_TIME);
  const [isButtonDisabled, setIsButtonDisabled] = useState<boolean>(true);

  const maskedPhoneNumber = `${mobileCountryCode} ${inputPhoneNumber.replace(
    /[0-9a-zA-Z](?=[0-9a-zA-Z]{4})/gi,
    '*'
  )}`;

  const onChange = (value: string) => {
    setOtpState((prevState: StateProps) => ({
      ...prevState,
      otpValue: value
    }));
    const validOtp = value.length < 6;
    setIsButtonDisabled(validOtp);
  };

  const handleNiumForexSendOtp = async () => {
    const ctData = {
      pageName: OTP_PAGE
    };
    activateLoader();
    if (otpState.otpSent) {
      const verificationResponse = await verifyMobileOtp(
        otpState.otpValue,
        inputPhoneNumber,
        mobileCountryCode,
        countryCode,
        {
          formID: formID
        }
      );
      if (verificationResponse) {
        onClose(true);
        logEvent('NF_OTPVerified', SIGNUP, ctData, LOG_TYPE.CLEVER_TAP);
        changeNiumForexScreen(NF_SCREENS.send_money);
      }
    } else {
      const response = await sendOtpOnMobile({
        is_send_otp: true,
        mobile_country_code: mobileCountryCode,
        mobile_number: inputPhoneNumber
      });
      if (response?.data?.success) {
        setOtpState((prevState: StateProps) => ({
          ...prevState,
          otpSent: true
        }));
        logEvent('NF_verifyCode', SIGNUP, ctData, LOG_TYPE.CLEVER_TAP);
        createTimer();
      }
    }
    disableLoader();
  };

  const handleSendOtp = async () => {
    activateLoader();
    if (otpState.otpSent) {
      const verificationResponse = await verifyOTPAuRevamp({ otp: otpState.otpValue });
      if (verificationResponse.success) {
        onClose(true);

        const nextScreen = verificationResponse?.nextOnboardProcess?.transitions[0].to;
        // OTP VERIFIED
        const ctData = {
          pageName: OTP_PAGE
        };
        logEvent('otpVerified', FLOW_TYPE_ONBOARDING, ctData, LOG_TYPE.CLEVER_TAP);
        changeOnBoardingScreen(nextScreen);
      }
    } else {
      const response = await sendOTPAuRevamped({
        mobileCountryCode: mobileCountryCode,
        mobileNumber: inputPhoneNumber
      });
      if (response.success) {
        setOtpState((prevState: StateProps) => ({
          ...prevState,
          otpSent: true
        }));
        createTimer();
      }
    }
    disableLoader();
  };
  const createTimer = () => {
    if (timer || countDown <= 0) {
      clearInterval(timer);
    }
    timer = setInterval(() => {
      setCountDown((prevState: number) => prevState - 1);
    }, 1000);
  };

  const handleResendOtp = async () => {
    activateLoader();
    setOtpState((prevState: StateProps) => ({
      ...prevState,
      otpSent: true
    }));
    !isNiumForexUser
      ? await sendOTPAuRevamped({
          mobileNumber: inputPhoneNumber,
          mobileCountryCode: mobileCountryCode
        })
      : await sendOtpOnMobile({
          is_send_otp: true,
          mobile_country_code: mobileCountryCode,
          mobile_number: inputPhoneNumber
        });
    setCountDown(OTP_WAIT_TIME);
    createTimer();
    disableLoader();
  };

  return (
    <ModalContainer
      containerMarginTop={6}
      buttonTopMargin={32}
      buttonWidth={335}
      width={450}
      height={!otpState.otpSent ? 356 : countDown > 0 && otpState.otpSent ? 466 : 496}
    >
      <CloseModalIcon src={CLOSE_HEAVY_ICON} onClick={() => onClose(false)} />
      <div className="modal-body-container">
        <span className="heading">{auOnBoardingConstants.OTP_HEADING}</span>
        <span className="otp-description">
          {otpState.otpSent
            ? auOnBoardingConstants.OTP_SENT_DESC
            : auOnBoardingConstants.OTP_INIT_DESC}
        </span>
        <div className="information-container">
          <span className="information-row">{maskedPhoneNumber}</span>
        </div>
        {otpState.otpSent && (
          <InputContainer>
            <PinInput
              length={6}
              inputProps={{
                className: 'fragment'
              }}
              autoFocus={true}
              onChange={onChange}
            />
          </InputContainer>
        )}
        <div className="modal-submit-button">
          <CommonButton
            text={otpState.otpSent ? 'Confirm' : 'Send verification code'}
            onClick={(e) => {
              e.preventDefault();
              !isNiumForexUser ? handleSendOtp() : handleNiumForexSendOtp();
            }}
            disabled={otpState.otpSent && isButtonDisabled}
            width={335}
            height={46}
          />
        </div>
        {otpState.otpSent && countDown > 0 && (
          <span className="timer-container">Resend code in {countDown} seconds</span>
        )}
        {otpState.otpSent && countDown <= 0 && (
          <div className="resend-code-container">
            <span className="text">{auOnBoardingConstants.OTP_NOT_RECEIVED}</span>
            <CenteredRow padding={[0, 0]}>
              <CommonButton
                type="link"
                onClick={handleResendOtp}
                text={auOnBoardingConstants.RESEND_OTP}
                width={420}
                height={46}
              />
            </CenteredRow>
          </div>
        )}
      </div>
    </ModalContainer>
  );
};

OtpModal.propTypes = {
  onClose: PropTypes.any,
  userStatusReducer: PropTypes.any,
  inputPhoneNumber: PropTypes.string,
  remitter_individual_mobile_country_code: PropTypes.string,
  sendOTPAuRevamped: PropTypes.func,
  verifyOTPAuRevamp: PropTypes.func,
  changeOnBoardingScreen: PropTypes.func,
  changeNiumForexScreen: PropTypes.func,
  sendOtpOnMobile: PropTypes.func,
  verifyMobileOtp: PropTypes.func
};

export default connect<any, any>(null, {
  sendOTPAuRevamped,
  verifyOTPAuRevamp,
  activateLoader,
  disableLoader,
  changeOnBoardingScreen,
  changeNiumForexScreen,
  verifyMobileOtp,
  sendOtpOnMobile
})(OtpModal);
